import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgFenaPayMethod = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={38}
    height={26}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <rect
      x={0.5}
      y={0.5}
      width={37}
      height={25}
      rx={4.5}
      fill="#fff"
      stroke="#DBE3EB"
    />
    <g clipPath="url(#fena-pay-method_svg__a)" fill="#13273F">
      <path d="M3 12.251h.715c.04-.586.157-1.087.351-1.503a2.79 2.79 0 0 1 .764-1.009c.321-.26.692-.451 1.09-.562.434-.121.883-.18 1.333-.177v1.79a2.659 2.659 0 0 0-.6.074c-.21.048-.411.132-.593.248-.183.116-.338.27-.455.452-.12.185-.185.419-.194.7l1.66-.013-.024 1.656H5.412v3.898H3.63l.012-3.885H3V12.25ZM11.639 17.88a3.6 3.6 0 0 1-2.575-1.072 3.707 3.707 0 0 1-.776-4.02 3.605 3.605 0 0 1 1.933-1.942 3.657 3.657 0 0 1 3.999.778 3.632 3.632 0 0 1 1.066 2.589v.718H9.93c.136.338.368.629.668.834.305.215.67.328 1.042.323.234.002.467-.042.685-.128.208-.082.399-.204.562-.36l1.32 1.219a3.61 3.61 0 0 1-1.15.78 3.56 3.56 0 0 1-1.418.28Zm-1.782-4.191h3.563a1.84 1.84 0 0 0-.655-.961 1.778 1.778 0 0 0-1.126-.378 1.804 1.804 0 0 0-1.12.378c-.157.12-.294.263-.407.424-.114.164-.2.345-.255.537ZM21.732 14.297c0-.324-.049-.604-.146-.84a1.54 1.54 0 0 0-.4-.578 1.645 1.645 0 0 0-.594-.333 2.355 2.355 0 0 0-.727-.11 2.19 2.19 0 0 0-.72.116 1.854 1.854 0 0 0-.587.327c-.17.143-.307.322-.4.524-.1.22-.149.459-.145.7L18 17.805h-1.746l-.024-3.507v-3.471h1.805l-.024.67c.221-.281.511-.5.842-.634a2.824 2.824 0 0 1 1.011-.219c2.433-.073 3.649 1.178 3.649 3.751l.012 3.41h-1.758l-.037-3.508ZM31.983 14.346v3.46h-1.817l.036-.495c-.557.46-1.18.69-1.866.69a3.648 3.648 0 0 1-3.362-2.243 3.709 3.709 0 0 1 0-2.848 3.649 3.649 0 0 1 3.362-2.241 3.648 3.648 0 0 1 3.363 2.24c.19.45.287.936.284 1.425v.012Zm-1.78-.006a1.881 1.881 0 0 0-2.229-1.85 1.852 1.852 0 0 0-1.358 1.117 1.917 1.917 0 0 0 0 1.466 1.84 1.84 0 0 0 1.714 1.136 1.891 1.891 0 0 0 1.325-.542 1.852 1.852 0 0 0 .547-1.327ZM34.262 17.94a.99.99 0 0 1-.932-.622 1.006 1.006 0 0 1-.074-.389v-.61h2.011v.61a1.001 1.001 0 0 1-.618.938.989.989 0 0 1-.387.073Z" />
    </g>
    <defs>
      <clipPath id="fena-pay-method_svg__a">
        <path fill="#fff" transform="translate(3 9)" d="M0 0h32.267v9H0z" />
      </clipPath>
    </defs>
  </svg>
);
const ForwardRef = forwardRef(SvgFenaPayMethod);
export default ForwardRef;
